// src/features/campManagement/campManagementSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface CampState {
  selectedCamp: any
}

const initialState: CampState = {
  selectedCamp: null,
}

const campManagementSlice = createSlice({
  name: 'campManagement',
  initialState,
  reducers: {
    setSelectedCamp(state, action: PayloadAction<any>) {
      state.selectedCamp = action?.payload
    },
  },
})

export const { setSelectedCamp } = campManagementSlice.actions

// Selectors
export const getSelectedCamp = (state: { campManagement: CampState }) =>
  state.campManagement.selectedCamp

export default campManagementSlice?.reducer
